import React from 'react';
import Credentials from '../components/Credentials';
import I18n from '../utils/I18n';

const EarnCredentialOverview = ({ lang, data }) => {
  const i18n = new I18n({ lang });

  let tableLink = i18n.text('overviewBanner_cardLink', 'TABLEAU');
  let mulesoftLink = i18n.text('overviewBanner_cardLink', 'MULESOFT');
  let slackLink = i18n.text('overviewBanner_cardLink', 'SLACK');

  return (
    <div className="">
      <div className="slds-text-align--center cert-earn-Overview_title slds-container--medium slds-container--center">
        <h2>{i18n.text('earnCredential_title')}</h2>
      </div>

      {data && data.length > 0 && data.map((item, index) => {
        return (
          <>
            <div className="slds-text-align--center cert-earn-Overview_subtitle">
              {item.description}
            </div>

            <Credentials names={[item.credential]} style="gray" lang={lang} />

            <div className="slds-text-align--center slds-m-top--x-large">
              <a
                className="slds-button slds-button_brand tds-button_x-large tds-button_brand"
                href={i18n.text('earnCredential_ctaLink')}
                target="_blank">
                {item.ctaText}
              </a>
            </div>


          </>
        );
      })}

      {data.length == 0 && (
        <>
          <div className="slds-text-align--center cert-earn-Overview_subtitle">
            {i18n.text('earnCredential_subtitle')}
          </div>
          <div className="slds-text-align--center slds-m-top--x-large">
            <a
              className="slds-button slds-button_brand tds-button_x-large tds-button_brand"
              href={i18n.text('earnCredential_ctaLink')}
              target="_blank">
              {i18n.text('earnCredential_ctaText')}
            </a>
          </div>
          {/* credentials cards start*/}
          <div className='slds-container_x-large slds-container_center'>
            <div className="slds-grid slds-wrap slds-p-vertical--x-large slds-p-horizontal_medium">
              {/* <div className="slds-p-around_medium slds-col slds-size_1-of-1 slds-small-size_1-of-1 slds-medium-size_1-of-2 slds-large-size_1-of-3 slds-align_absolute-center">
                  <div className='cert-earn-Overview_card slds-align_absolute-center'>
                    <img className="cert-overview-hero_card-link_icon" src="https://developer.salesforce.com/resources2/certification-site/images/hero/slack.png" alt="Slack Logo" />
                    <span className="cert-overview-hero_card-link_text">
                      <a dangerouslySetInnerHTML={{ __html: slackLink }} href="https://www.slackcertified.com/" />
                    </span>
                  </div>
              </div> */}
              <div className="slds-p-around_medium slds-col slds-size_1-of-1 slds-small-size_1-of-1 slds-medium-size_1-of-2 slds-large-size_1-of-3 slds-align_absolute-center">
                <div className='cert-earn-Overview_card slds-align_absolute-center'>
                  <img className="cert-overview-hero_card-link_icon" src="https://developer.salesforce.com/resources2/certification-site/images/hero/Tableau.png" alt="Tableau Logo" />
                  <span className="cert-overview-hero_card-link_text">
                    <a dangerouslySetInnerHTML={{ __html: tableLink }} href="https://www.tableau.com/learn/certification" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* credential cards ends */}
        </>
      )}
    </div>
  );
};

export default EarnCredentialOverview;
